<!-- eslint-disable -->
<template>
  <div class="d-flex align-items-center justify-content-center" v-if="StateUser">
    <div class="row w-100 mx-0 auth-page">
      <div class="col-md-12 col-xl-12 mx-auto">
        <div class=" ">
          <SectionLoaderView v-if="loadingRequest?.AssignUserToStore" />
          <div class="row">
            <div class="col-md-12 stretch-card">
              <div class="card">
                <div class="card-body">
                  <p href="#" class="noble-ui-logo d-block mb-2">Assigner un utilisateur <span>&nbsp;à plusieurs
                      magasins
                    </span>
                  </p>
                  <!-- Informational Message for Client -->
                  <p class="info-message mt-4 mb-4">
                    <i><b>Note</b> : Sélectionnez un ou plusieurs magasins et ajouter email d'utilisateur à y
                      assigner</i>
                  </p>
                  <form @submit.prevent="SubmitAssignUserToStore">
                    <div class="row">
                      <div class="col-md-12 mb-3">
                        <div class="">
                          <label for="userEmail" class="form-label">Adresse e-mail</label>
                          <input type="email" class="form-control" id="userEmail" placeholder="Adresse e-mail"
                            autocomplete="Email" v-model="form.email" />
                        </div>


                        <div class="errors-response" v-if="v$.form.email.$error">
                          <p v-if="!v$.form.email.required.$response">{{ $t('validation.required') }}
                          </p>
                          <p v-if="!v$.form.email.email.$response">{{ $t('validation.email') }}
                          </p>
                          <p class="error" v-if="!v$.form.email.minLength.$response">
                            {{ $t('validation.min.string', {
                              attribute: 'email', min: v$.form.email.minLength.$params.min
                            }) }}
                          </p>
                          <p class="error" v-if="!v$.form.email.maxLength.$response">
                            {{ $t('validation.max.string', {
                              attribute: 'email', max: v$.form.email.maxLength.$params.max
                            }) }}
                          </p>
                        </div>
                      </div>
                      <div class="col-sm-12 mt-3">
                        <div class="mb-3">

                          <div class="row">
                            <div v-if="$store?.state?.managerWithStores?.associatedRestaurants" class="col-md-12">
                              <div>
                                <label class="form-label">Liste des restaurants :</label>

                                <Multiselect v-model="selectedstoresToAccept"
                                  :options="$store.state.managerWithStores?.associatedRestaurants" :multiple="true"
                                  track-by="_id" label="LibSite" placeholder="Select users" />
                                <div class="errors-response" v-if="v$.form.storesToAccept.$error">
                                  <p v-if="!v$.form.storesToAccept.required.$response">{{ $t('validation.required') }}
                                  </p>

                                </div>

                              </div>
                            </div>

                          </div>
                        </div>
                      </div>




                    </div>
                    <!-- Row -->
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="mb-3 mt-3">
                          <!-- Submit Button -->
                          <button type="submit" class="w-100 btn btn-primary submit">
                            Envoyer
                          </button>


                        </div>
                      </div>
                    </div>
                    <!-- Row -->
                  </form>
                </div>
              </div>
            </div>

          </div>
          <div class="row mt-5">
            <div class="col-md-12 stretch-card">
              <div class="card">
                <div class="card-body">
                  <p href="#" class="noble-ui-logo d-block mb-2">Accepter l'invitation<span>&nbsp; du restaurant
                      magasins
                    </span>
                  </p>
                  <!-- Informational Message for Client -->
                  <p class="info-message mt-4 mb-4">
                    <i>
                      <b>Note</b> : Si vous n'avez pas reçu l'e-mail pour accepter l'invitation au magasin, essayez
                      d'ajouter
                      ici le
                      token partagé par le super administrateur, puis cliquez sur le bouton “Accepter” .
                    </i>
                  </p>
                  <form @submit.prevent="testacceptInviteStore">
                    <div class="row">
                      <div class="col-sm-12 mt-3">
                        <label class="form-label"> Ajouter le token ici :</label>
                        <input type="text" class="form-control" autocomplete="token" placeholder="Token"
                          v-model="accept.tokenAssignUserToStore" />
                        <div class="errors-response" v-if="v2$.accept.tokenAssignUserToStore.$error">
                          <p v-if="!v2$.accept.tokenAssignUserToStore.required.$response">{{ $t('validation.required') }}
                          </p>

                        </div>
                      </div>


                    </div>
                    <!-- Row -->
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="mb-3 mt-3">
                          <!-- Submit Button -->
                          <button type="submit" class="w-100 btn btn-primary submit">
                            Accepter
                          </button>


                        </div>
                      </div>
                    </div>
                    <!-- Row -->
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- eslint-disable -->
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, minLength, maxLength, email, requiredIf, decimal, numeric, helpers, sameAs } from "@vuelidate/validators";
const { withParams } = helpers;
import Swal from 'sweetalert2'

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import { alertSwal } from "@/Utils/globale.js";

export default {
  name: "EditprofileView",
  components: {
    Multiselect
  },

  mounted() {

  },
  data() {
    return {
      accept: {
        tokenAssignUserToStore: null,
      },
      selectedstoresToAccept: [],
      form: {
        storesToAccept: [],
        email: ""
      },
    };
  },
  setup: () => ({ v$: useVuelidate(), v2$: useVuelidate() }), 
  validations() {
    return {
      form: {
        storesToAccept: {
          required,
        },
        email: {
          email,
          required,
          minLength: minLength(1),
          maxLength: maxLength(350)
        },

      },
      accept: {
        tokenAssignUserToStore: {
          required,
        },

      }
    };
  },
  methods: {

    ...mapActions(['AssignUserToStore', "acceptInviteStore"]),
    async SubmitAssignUserToStore() {
      this.v$.form.$touch();
      if (
        !this.v$.form.$invalid
      ) {
        const user = {
          email: this.form.email,
          storesToAccept: this.form.storesToAccept,
        };
        try {
          await this.AssignUserToStore(user).then(async (res) => {

            if (typeof res === "undefined") {
              const result = await Swal.fire({
                title: "Email introuvable ou une erreur s'est produite. Veuillez réessayer",
                icon: 'error',
              })

            } else {

              this.form.email = null
              this.form.storesToAccept = null
              this.accept.tokenAssignUserToStore = null
              this.selectedstoresToAccept = []


              const result = await Swal.fire({
                title: 'Invitation envoyée avec succès',
                html: `
     <label class="mt-4 form-label"> Voici le token généré :</label>
    <input type="text" class="form-control" autocomplete="token" placeholder="Token" style="width: 100%; padding: 8px; text-align: center;"  value="${res?.data?.tokenAssignUserToStore}" readonly>
     <button class="w-100 mt-4 btn btn-primary submit" onclick="navigator.clipboard.writeText('${res?.data?.tokenAssignUserToStore}')">Copier le token</button>
    <p class="mt-4">Partagez ce token avec l'utilisateur invité.</p>
  `,
                icon: 'success',
                showConfirmButton: true,
                confirmButtonText: 'OK'
              })
              if (result?.isConfirmed) {
                this.form.email = null
                this.form.storesToAccept = null
                this.accept.tokenAssignUserToStore = null
                this.selectedstoresToAccept = []

              }

            }
          })


        } catch (error) {
          console.log(error);
          if (error.response.status === 403) {
            alertSwal("error", "Forbidden");
            return;
          }
          alertSwal("error", "Il y a un problème, veuillez réessayer s'il vous plaît");
        }
      } else {
        console.log('Form has errors. Please fix them.');
        return;
      }
    },


    async testacceptInviteStore() {
      this.v2$.accept.$touch();
      if (
        !this.v2$.accept.$invalid
      ) {
        const user = {
          tokenAssignUserToStore: this.accept.tokenAssignUserToStore,
        };
        try {
          await this.acceptInviteStore(user);

        } catch (error) {
          console.log(error);
          if (error.response.status === 403) {
            alertSwal("error", "Forbidden");
            return;
          }
          alertSwal("error", "Il y a un problème, veuillez réessayer s'il vous plaît");
        }
      }
    },



  },
  watch: {
    selectedstoresToAccept(val) {
      this.form.storesToAccept = this.selectedstoresToAccept.map(u => u._id)
    }
  },
  computed: {
    ...mapGetters({ ManagerWithStore: "StateManagerWithStore", StateUser: "StateUser", isRole: "isRole", isAuthenticated: "isAuthenticated", BaseUrl: "StateBase", currentSite: "currentSite", parametrages: "StateParametrages", StateIsAbonnementActif: "StateIsAbonnementActif" }),
    ...mapState({ appVersion: 'appVersion', loadingRequest: 'loadingRequest' }),
  },


};
</script>
<!-- eslint-disable -->
<style scoped></style>